const riot = require('riot');

riot.tag2('page-admin-companies-single', '<div class="f"> <div class="h100vh sticky t0" data-is="module-sidebar"></div> <form class="w-full f fclm p40 bg-gray_light_10" if="{!company &amp;&amp; !isLoading}" onsubmit="{onCreateCompany}"> <div class="mb20"><a class="f fm text-gray_dark_20 mb2" href="/admin/companies"><i class="material-icons">navigate_before</i> <div class="lh14 fw5">ダッシュボード</div></a> <div class="lh15 fs30 fw3">新規会社登録 </div> </div> <div class="f fclm p20 bg-white"> <div class="border-bottom border-gray_light_10 pb16 mb16"> <label class="block mb16"> <div class="lh14 fw5 mb6">会社名</div> <input class="input w40per" ref="company" type="text" required placeholder="会社名を記入してください" oninput="{dataChange}"> </label> <label class="block"> <div class="lh14 fw5 mb6">メアド</div> <input class="input w40per" ref="email" required placeholder="メアドを記入してください" oninput="{dataChange}" type="email"> </label> </div> <div class="f fr"> <button class="button primary">保存</button> </div> </div> </form> <div class="w-full f fclm bg-gray_light_10 p40" if="{company &amp;&amp; !isLoading}"><a class="f fm flex-fixed text-gray_dark_20 mb2" href="/admin/companies"><i class="material-icons">navigate_before</i> <div class="lh14 fw5">ダッシュボード</div></a> <div class="f fm fbw flex-fixed mb48"> <div class="lh15 fs30 fw3 word-break-all">{company.name}</div> <div class="f fm flex-fixed"><a class="block mr8" href="/app/companies/{this.company.id}" target="_blank"> <button class="button primary">会社ページに移動する</button></a></div> </div> <form class="f fclm bg-white p20 mb48" onsubmit="{onSubmitInvoice}"> <div class="pb20 border-bottom border-gray_light_10 mb20"> <div class="mb20"> <div class="ts-h5 text-gray_dark_20 mb4">会社名</div> <div class="ts-h5">{company.name}</div> </div> <div class="mb20"> <div class="ts-h5 mb4">販売元</div> <input class="input size-s max-width-640 w-full" ref="sales_agent" type="text" placeholder="Repro株式会社" riot-value="{billingSetting.sales_agent}"> </div> <div class="mb20"> <div class="ts-h5 mb4">請求先</div> <input class="input size-s max-width-640 w-full" ref="bill_to" type="text" placeholder="Repro株式会社" riot-value="{billingSetting.bill_to}"> </div> <div class="mb20"> <div class="ts-h5 mb4">手数料率</div> <input class="input size-s max-width-239 w-full" ref="commission_rate" placeholder="0.3" step="0.1" riot-value="{billingSetting.commission_rate}" type="{\'number\'}"> </div> <div class="mb20"> <div class="ts-h5 mb4">安全しきい値（これ以下にポイント残高がなったら前もって請求する）</div> <input class="input size-s max-width-239 w-full" ref="balance_charge_threshold" placeholder="10000" riot-value="{billingSetting.balance_charge_threshold}" type="{\'number\'}"> </div> <div class="mb20"> <div class="ts-h5 mb4">請求しきい値（これ以下にポイント残高がなったら請求する）</div> <input class="input size-s max-width-239 w-full" ref="balance_charge_warning_threshold" placeholder="10000" riot-value="{billingSetting.balance_charge_warning_threshold}" type="{\'number\'}"> </div> <div class="mb20"> <div class="ts-h5 mb4">請求金額 </div> <input class="input size-s max-width-239 w-full" ref="default_charge_amount" placeholder="10000" riot-value="{billingSetting.default_charge_amount}" type="{\'number\'}"> </div> <div class="inline-block mb20"> <label class="f fm cursor-pointer"> <input class="checkbox mr10" ref="is_subscription" type="checkbox" checked="{billingSetting.is_subscription}"> <div>請求継続する</div> </label> </div> <div class="mb20"> <div class="ts-h5 text-gray_dark_20 mb4">オプション機能</div> <div each="{option in app.data.constants.company_option_types}"> <label class="f fm cursor-pointer mb8"> <input class="checkbox mr10" ref="{option.id}" type="checkbox" checked="{company.enabled_option_types.includes(option.id)}"> <div>{option.name}</div> </label> </div> </div> <div class="mb20"> <div class="ts-h5 text-gray_dark_20 mb4">利用可能券種</div> <div each="{option in providersOptions}"> <label class="f fm cursor-pointer mb8"> <input class="checkbox mr10" ref="provider" type="checkbox" riot-value="{option.id}" checked="{companyPointProviders.includes(option.id)}"> <div>{option.name}</div> </label> </div> </div> </div> <div class="f fr"> <button class="button primary">保存 </button> </div> </form> <div class="f fclm bg-white p20 mb48"> <div class="f fbw fm w-full mb24"> <div class="f fr w-full mr40"> <div class="w220 text-right mr24"> <div class="ts-hs text-gray_60 mb8">累積入金金額</div> <div class="ts-hl text-navy">{totalDepositAmount.toLocaleString()}円</div> </div> <div class="w220 text-right mr24"> <div class="ts-hs text-gray_60 mb8">累積発行金額</div> <div class="ts-hl text-navy">{totalConsumedAmount.toLocaleString()}円</div> </div> <div class="w220 text-right"> <div class="ts-hs text-gray_60 mb8">ポイント購入可能残高</div> <div class="ts-hl text-navy">{(totalDepositAmount - totalConsumedAmount).toLocaleString()}円</div> </div> </div><a class="flex-fixed button primary" href="/admin/companies/{id}/deposit_histories/new">入金履歴を追加</a> </div> <div class="f fclm"> <div class="max-height-320" data-is="module-table" schemas="{tableSchemas}" items="{histories}" scroll-type="y"></div> <div class="f fr mta mr20"> <div ref="history_pagination" data-is="atom-pagination" pagination="{historyPagination}"></div> </div> </div> </div> <div class="f fclm p20 bg-white overflow-y-scroll mb48"> <div class="f fm fbw mb20"> <div class="lh12 fs16 fw5">配布ルール</div> </div> <div class="relative w160 mb20"> <select class="select s-full lh14 cursor-pointer" ref="filter" onchange="{onChangeFilter}"> <option each="{status in app.data.constants.distribution_rule_statuses}" riot-value="{status.id}">{status.name}</option> <option value="" selected>全て</option> </select> <div class="absolute r8 t0 b0 f fh pointer-none"><i class="material-icons fs20 text-gray_dark_10">arrow_drop_down</i></div> </div> <div class="f fclm overflow-y-scroll max-height-320"> <div> <div class="f fm border-bottom border-top border-gray_light_10 bg-primary_light_50 py10 px16"> <div class="flex-fixed w142">更新日時</div> <div class="flex-fixed w102 pl16">ステータス</div> <div class="flex-fixed w180 pl16">配布ルール名</div> <div class="w-full pl16">会社名</div> <div class="w-full pl16">プロジェクト名</div> <div class="w-full pl16">キャンペーン名</div> </div> <div class="s-full mb20"> <div class="f fm fbw px16 py20 border-bottom border-gray_light_10 lh14 {&quot;bg-gray_light_20 text-gray_dark_20&quot;: !!rule.archived_at}" each="{rule in distributionRules}"> <div class="flex-fixed f fm w142"><i class="material-icons fs20 mr4" if="{!!rule.archived_at}">archive</i> <div class="line-clamp-1">{dayjs(rule.updated_at).format(\'YYYY-MM-DD HH:mm\')}</div> </div> <div class="flex-fixed f w102 pl16"> <div class="f fm py4 px7 rounded-4 text-white bg-{getStatus(rule).color}"><i class="material-icons fs12 mr4">{getStatus(rule).icon}</i> <div class="fs12">{getStatus(rule).name}</div> </div> </div> <div class="flex-fixed w180 pl16 line-clamp-1 word-break-all">{rule.name}</div> <div class="w-full pl16 line-clamp-1 word-break-all">{rule.company.name}</div> <div class="w-full pl16 line-clamp-1 word-break-all">{rule.project.name}</div> <div class="w-full pl16 line-clamp-1 word-break-all">{rule.campaign.name}</div> </div> </div> </div> </div> <div class="f fr mta mr20 mb36"> <div data-is="atom-pagination" ref="distribution_rule_pagination" pagination="{distributionRulesPagination}"></div> </div> <div class="f fm fbw border border-error px24 py16"> <div class="text-gray_dark_50"> <div class="lh12 fw5 fs16 mb4">全配布ルールのアーカイブ</div> <div class="lh14 fw4">この会社に紐づく全ての配布ルールを強制アーカイブします。この操作を元に戻す事はできません。</div> </div> <button class="button danger" onclick="{onEndCampaign}">アーカイブ</button> </div> </div> <div class="f fm fbw border px24 py16 bg-white"> <div class="text-gray_dark_50"> <div class="lh12 fw5 fs16 mb8">企業を『無効化』する</div> <div class="lh14 fw4 text-gray_60">企業が『無効化』されると、一覧画面に表示されなくなります。また、企業に紐付く各ページへのアクセスできなくなります。</div> <div class="lh14 fw4 text-gray_60">再度有効化を希望される場合は、開発チームまでご連絡ください。</div> </div> <button class="button danger" onclick="{onDeleteCompany}">無効化</button> </div> </div> </div>', 'page-admin-companies-single,[data-is="page-admin-companies-single"]{display:block}', '', function(opts) {

    this.isLoading = true;
    this.limit = 50;
    this.tableSchemas = [
      {
        id: 'apply_at',
        label: '反映日',
        class: 'w132 flex-fixed',
        getText: (v) => dayjs(v).format('YYYY-MM-DD'),
      },
      {
        id: 'amount',
        label: '金額(円)',
        class: 'w110 flex-fixed',
        align: 'right',
        getText: (v, h) => h.deal_type === 'refund' ? `-${v.toLocaleString()}` : v.toLocaleString(),
      },
      {
        id: 'reason',
        label: 'コメント',
        class: 'min-width-200 w0 flex-auto',
      },

      {
        id: 'menu',
        component: 'material-icon-button',
        text: 'more_vert',
        align: 'center',
        class: 'flex-fixed w52',
        onclick: (history, e) => {
          this.openHistoryMenu(history, e);
        },
      },
    ];

    this.preload = async ({req, res, cached}) => {
      if (spat.isNode || (req.isBack && cached)) return;
      app.utils.auth.validateOperator();
      this.isLoading = true;
      this.update();

      var id = req.params.id;
      this.id = id;
      if (id === 'new') {
        this.isLoading = false;
        this.update();
        return;
      }

      var promises = [
        app.api.child(`companies/${id}`).get(),
        app.api.child(`companies/${id}/billing_setting`).get(),
        app.api.child(`companies/${id}/point_deposit_histories/summary`).get(),
        app.api.child(`companies/${id}/point_providers`).get(),
        this.fetchDistributionRules(),
      ];
      var [{ company }, { billingSetting }, { total_deposit_amount, total_consumed_amount }, { company_point_providers }] = await Promise.all(promises);
      this.billingSetting = billingSetting;
      this.company = company;

      this.totalDepositAmount = total_deposit_amount;

      this.totalConsumedAmount = total_consumed_amount;

      this.providersOptions = app.data.constants.point_providers.filter(provider => provider.id !== "test_point_provider");

      this.companyPointProviders = company_point_providers.map(item => item.point_provider);
      this.historyPagination = null;
      this.histories = [];
      await this.fetchHistories();
      this.isLoading = false;
      this.update();

      this.refs.distribution_rule_pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = this.distributionRulesPagination[offset_type];
        var status = this.refs.filter.value;
        var query = {
          offset,
          status,
        };
        try {
          this.fetchDistributionRules(query);
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      });

      this.refs.history_pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = this.historyPagination[offset_type];
        try {
          await this.fetchHistories({ offset });
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      });

    };

    this.head = () => {
      return {
        title: app.utils.head.title('会社設定', this),
      };
    };

    this.on('beforeunload', async (e) => {
      if (this.isChange) {
        e.returnValue = app.data.beforeunload_text;
      }
    });

    this.on('show', () => {
      this.isChange = false;
    });

    this.dataChange = () => {
      this.isChange = true;
    };

    this.onCreateCompany = async (e) => {
      var indicator = spat.modal.indicator();
      e.preventDefault();
      try {
        var email = this.refs.email.value;
        var query = {
          name: this.refs.company.value,
          email,
        };
        await app.api.child('companies').post(query);

        spat.modal.alert('作成しました');
        spat.router.push('/admin/companies');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onEndCampaign = async () => {
      var modal = await spat.modal.open('modal-confirm', {
        title: '全てのキャンペーンを停止しますか?',
        text: 'この会社に紐づく全てのキャンペーンを強制瞬時停止します。この操作を元に戻す事はできません。',
        positive: '停止',
        check_form: {
          key: '会社名を入力してください',
          value: this.company.name,
        },
      });

      var result = await modal.waitClose();
      if (!result) return;
      var indicator = spat.modal.indicator();
      try {
        await app.api.child(`companies/${this.company.id}/stop`).post({});
        spat.toast.message('キャンペーンを停止しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onDeleteCompany = async () => {
      var modal = await spat.modal.open('modal-confirm', {
        title: `企業 "${this.company.name}" を『無効化』しますか？`,
        text: 'この企業に紐づく全ての情報が閲覧・編集できなくなります。\n再度有効化を希望される場合は、開発チームまでご連絡ください。',
        positive: '無効化',
      });

      var result = await modal.waitClose();
      if (!result) return;
      var indicator = spat.modal.indicator();
      try {
        await app.api.child(`companies/${this.company.id}/deactivate`).post({});
        spat.toast.message(`企業 "${this.company.name}" を『無効化』しました。`);

        spat.router.push('/admin/companies/');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onGoProjectSingle = (e) => {
      spat.router.push(`/app/companies/${this.company.id}/projects/${e.item.project.id}`);
    };

    this.fetchHistories = async ({offset = 0} = {}) => {
      var query = {
        offset,
        limit: this.limit,
      };
      var { point_deposit_histories, pagination } = await app.api.child(`companies/${this.id}/point_deposit_histories`).get(query);

      this.histories = point_deposit_histories;
      this.historyPagination = pagination;
      this.update();
    };

    this.openHistoryMenu = (history, e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "pencil",
          label: "入金履歴の編集",
          action: () => {
            popup.close();
            spat.router.push(`/admin/companies/${this.id}/deposit_histories/${history.id}/edit`);
          },
        }
      ];
      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        position: 'bottom',
        align: {x: 'right'},
        opts: {
          options,
        }
      });
    };

    this.fetchDistributionRules = async ({offset = 0, status} = {}) => {
      var indicator = spat.modal.indicator();
      try {
        var {distribution_rules, pagination} = await app.api.child(`companies/${this.id}/distribution_rules`).get({offset, status, limit: this.limit});
        this.distributionRules = distribution_rules;
        this.distributionRulesPagination = pagination;
        this.update();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.getStatus = (rule) => {
      return app.data.constants.distribution_rule_statuses.find(s => s.id === rule.status);
    };

    this.onChangeFilter = async () => {
      var status = this.refs.filter.value;
      var query = {
        status,
      };
      var indicator = spat.modal.indicator();
      try {
        this.fetchDistributionRules(query);
      }
      catch (e) {
        console.error(e)
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.onSubmitInvoice = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      var query = {
        balance_charge_threshold: Number(this.refs.balance_charge_threshold.value),
        balance_charge_warning_threshold: Number(this.refs.balance_charge_warning_threshold.value),
        bill_to: this.refs.bill_to.value,
        commission_rate: Number(this.refs.commission_rate.value),
        default_charge_amount: Number(this.refs.default_charge_amount.value),
        is_subscription: this.refs.is_subscription.checked,
        sales_agent: this.refs.sales_agent.value,
      };

      var company_query = {
        enabled_option_types: app.data.constants.company_option_types.filter(option => this.refs[option.id].checked).map(option => option.id),
      };

      let selected_providers = [].concat(this.refs['provider'] || []).flatMap(p => p.checked ? p.value : []);

      try {
        var promises = [
          app.api.child(`companies/${this.id}`).put(company_query),
          app.api.child(`companies/${this.id}/billing_setting`).put(query),
          app.api.child(`companies/${this.id}/point_providers`).put({ point_providers: selected_providers }),
        ];
        await Promise.all(promises);
        spat.modal.alert('保存しました');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };
});